import { toastr } from 'react-redux-toastr';
import { ITINERARY_CLOSURE_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_ITINERARY_CLOSURE,
  FLAG_ITINERARY_CLOSURE_ACTIVITY,
  GET_ITINERARY_CLOSURE,
} from '../types';

const flagItineraryClosureActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ITINERARY_CLOSURE_ACTIVITY,
    payload: flag,
  });

const getItineraryClosure =
  async ({ itineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagItineraryClosureActivity(true));

      const url = `${ITINERARY_CLOSURE_ENDPOINT}/${itineraryId}`;
      const promise = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(promise, null, dispatch);

      const text = await promise.text();
      const response = text ? JSON.parse(text) : {};

      dispatch({
        type: GET_ITINERARY_CLOSURE,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagItineraryClosureActivity(false));
    }
  };

const clearItineraryClosure = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_CLOSURE,
  });

export { getItineraryClosure, clearItineraryClosure };
